import axios from "axios";

const DEFAULT_BACKEND_URL = "https://clink-backend-production-cd34.up.railway.app";

const normalizeBaseUrl = (value) => {
  const base = (value || DEFAULT_BACKEND_URL).trim().replace(/\/$/, "");
  return base.endsWith("/api") ? base.slice(0, -4) : base;
};

export const BACKEND_URL = normalizeBaseUrl(
  process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_BASE_URL
);

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cherishlink_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!["/login", "/signup", "/forgot-password", "/"].includes(path)) {
        localStorage.removeItem("cherishlink_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
